import { useEffect } from 'react';

import firebase from '../firebase';
import useFirebaseReducer, { DefaultData, FirebaseReducerActions } from './use-firebase-reducer';

const useReview = (userId, reviewId) => {
    const [ data, dispatch ] = useFirebaseReducer(DefaultData);
    useEffect(() => {
        let unsubscribe = null;

        async function subscribe() {
            unsubscribe = await firebase.reports.reviews.getReview(
                userId,
                reviewId,
                (snapshot) => {
                    dispatch({
                        type: FirebaseReducerActions.Snapshot,
                        data: snapshot,
                        isExisting: !snapshot.empty
                    });
                },
                (error) => {
                    if (error?.code === 'permission-denied')
                        dispatch({ type: FirebaseReducerActions.Forbidden });
                }
            );
        }

        if (userId && reviewId)
            subscribe();

        return () => {
            if (unsubscribe)
                unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ userId, reviewId]);

    return data;
};

export default useReview;
